import type { FC } from 'react'
import React from 'react'
import { useQuery } from '@apollo/react-hooks'
import { GET_PAGE_BY_SLUG } from '../../modules/core/queries'
import { AkaTypography } from '../index'
import { Markdown } from '../markdown/Markdown'
import { useTranslation } from 'react-i18next'

interface ContentProps {
	slug: string
}

export const Content: FC<ContentProps> = ({ slug }) => {
	const [t] = useTranslation()
	const { loading, error, data } = useQuery(GET_PAGE_BY_SLUG, {
		fetchPolicy: 'network-only',
		variables: {
			slug: slug
		}
	})

	return (
		<>
			{loading ? (
				<AkaTypography variant="bodySegoe2">
					{t('content.loading')}
				</AkaTypography>
			) : error ? (
				<AkaTypography variant="bodySegoe2" color="error">
					{t('content.error')}
				</AkaTypography>
			) : data?.pageBySlug ? (
				<>
					<div style={{ padding: '24px 48px' }}>
						<Markdown>{data?.pageBySlug.content}</Markdown>
					</div>
				</>
			) : (
				<AkaTypography variant="bodySegoe2">
					{t('content.notFound')}
				</AkaTypography>
			)}
		</>
	)
}
